// Presentation only. Native product IDs, variant IDs and uploaded file fields are retained.
const colors = [
  ['Soft Charcoal', '#56534f'], ['Clay', '#af7963'], ['Taupe', '#9f8b78'],
  ['Dusty Blue', '#91a5ad'], ['Oatmeal Beige', '#c7bba8'], ['Heather Gray', '#afafad'],
  ['Dusty Pink', '#c99c9b'], ['Ivory Cream', '#e8e5d7'], ['Rosewood', '#9e6c70'],
  ['Soft Cream', '#e7dfcc'], ['Sage Green', '#8a977f'],
];
function element(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}
function init() {
  const data = document.getElementById('baby-beanie-family-data');
  const details = document.querySelector('.product-details');
  if (!data || !details || details.querySelector('.beanie-family')) return;
  const { products, initial } = JSON.parse(data.textContent);
  const component = details.querySelector('product-form-component');
  const form = component?.querySelector('form');
  const nativeGallery = details.closest('.shopify-section')?.querySelector('media-gallery');
  const title = details.querySelector('h1');
  if (!form || !nativeGallery || !title || products.length !== colors.length) return;
  const lightness = hex => {
    const rgb = hex.match(/[a-f\d]{2}/gi).map(n => parseInt(n, 16) / 255);
    const linear = rgb.map(n => n <= .04045 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4);
    return .2126 * linear[0] + .7152 * linear[1] + .0722 * linear[2];
  };
  const members = products.map((p, i) => ({ ...p, color: colors[i][0], swatch: colors[i][1] }))
    .sort((a, b) => lightness(b.swatch) - lightness(a.swatch));
  const box = element('section', 'beanie-family');
  const fieldset = element('fieldset');
  const legend = element('legend', '', 'Design color: ');
  const selected = element('span'); legend.append(selected);
  const buttons = element('div', 'beanie-family__colors');
  fieldset.append(legend, buttons); box.append(fieldset);
  box.append(element('p', 'beanie-family__note', 'One size · Printed background colors. Swatches are approximate screen colors.'));
  const error = element('p', 'beanie-family__error'); error.setAttribute('role', 'alert'); box.append(error);
  const gallery = element('div', 'beanie-family__gallery');
  gallery.tabIndex = 0; gallery.setAttribute('role', 'region');
  gallery.setAttribute('aria-label', 'Selected baby beanie product images');
  gallery.setAttribute('aria-roledescription', 'carousel');
  const stage = element('div', 'beanie-family__stage');
  const previous = element('button', 'beanie-family__arrow', '‹'); previous.type = 'button';
  previous.setAttribute('aria-label', 'Previous product image');
  const next = element('button', 'beanie-family__arrow', '›'); next.type = 'button';
  next.setAttribute('aria-label', 'Next product image');
  const image = element('img', 'beanie-family__hero'); image.width = 1400; image.height = 1400;
  const thumbs = element('div', 'beanie-family__thumbs'); thumbs.setAttribute('aria-label', 'Selected color product views');
  const caption = element('p', 'beanie-family__caption');
  caption.setAttribute('aria-live', 'polite');
  stage.append(previous, image, next); gallery.append(stage, thumbs, caption);
  const colorProperty = element('input'); colorProperty.type = 'hidden'; colorProperty.name = 'properties[Design color]'; form.append(colorProperty);
  const idInput = form.querySelector('[name="id"]');
  const submitButtons = [...form.querySelectorAll('[type="submit"]')];
  let current;
  let currentView = 0;
  let imageRevision = 0;
  let revision = 0;
  function view(index) {
    const count = current?.images.length || 0; if (!count) return;
    currentView = ((index % count) + count) % count;
    const source = current.images[currentView];
    const imageToken = ++imageRevision;
    image.dataset.ready = 'false'; gallery.setAttribute('aria-busy', 'true');
    image.onload = () => {
      if (imageToken !== imageRevision) return;
      image.dataset.ready = 'true'; gallery.setAttribute('aria-busy', 'false');
    };
    image.src = source.url;
    if (image.complete && image.naturalWidth && image.currentSrc === new URL(source.url, location.href).href) image.onload();
    image.alt = `${current.color} baby beanie — ${source.alt || 'example personalized pet artwork'}`;
    thumbs.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-pressed', String(i === currentView)));
    caption.textContent = `${current.color} · View ${currentView + 1} of ${count}. Example pet artwork shown. Your own pet’s photo will be used.`;
  }
  previous.addEventListener('click', () => view(currentView - 1));
  next.addEventListener('click', () => view(currentView + 1));
  gallery.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    view(event.key === 'Home' ? 0 : event.key === 'End' ? current.images.length - 1 : currentView + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let pointerStart;
  image.draggable = false;
  image.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0) return;
    pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    image.setPointerCapture(event.pointerId);
  });
  image.addEventListener('pointerup', event => {
    if (!pointerStart || event.pointerId !== pointerStart.id) return;
    const dx = event.clientX - pointerStart.x; const dy = event.clientY - pointerStart.y;
    pointerStart = null;
    if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) view(currentView + (dx < 0 ? 1 : -1));
  });
  image.addEventListener('pointercancel', () => { pointerStart = null; });
  function choose(member, updateUrl = true) {
    revision++;
    const token = revision;
    current = member;
    selected.textContent = member.color;
    colorProperty.value = member.color;
    buttons.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-pressed', String(members[i] === member)));
    title.textContent = 'Custom Pet Portrait Baby Beanie';
    const valid = Boolean(member.id && member.variant?.id && member.images.length);
    if (idInput) { idInput.value = valid ? String(member.variant.id) : ''; idInput.setAttribute('value', idInput.value); }
    component.dataset.productId = String(member.id || '');
    const productInput = form.querySelector('[name="product-id"]'); if (productInput) productInput.value = String(member.id || '');
    details.querySelectorAll('product-price').forEach(price => {
      const node = price.querySelector('.price'); if (node) node.textContent = member.priceHtml || '';
      price.dataset.productId = String(member.id || '');
    });
    const services = form.querySelector('artwork-services');
    if (services) {
      services.product = { id: member.id, variants: member.variant ? [member.variant] : [] };
      services.dataset.productTitle = `${title.textContent} – ${member.color}`;
      services.sync?.();
    }
    const available = valid && member.variant.available;
    submitButtons.forEach(button => { button.disabled = !available; });
    error.textContent = available ? '' : 'This design color is currently unavailable. Please choose another color.';
    thumbs.replaceChildren();
    member.images.forEach((source, i) => {
      const button = element('button', 'beanie-family__thumb'); button.type = 'button';
      button.setAttribute('aria-label', `${member.color}, view ${i + 1} of ${member.images.length}`);
      const thumb = element('img'); thumb.src = source.url; thumb.alt = ''; thumb.width = 78; thumb.height = 78; thumb.loading = 'lazy';
      button.append(thumb); button.addEventListener('click', () => { if (token === revision) view(i); }); thumbs.append(button);
    });
    if (valid) view(0); else image.removeAttribute('src');
    if (updateUrl && valid) {
      const url = new URL(location.href); url.pathname = member.url; url.searchParams.set('variant', String(member.variant.id));
      history.replaceState(history.state, '', url);
    }
    // Trigger existing subtotal/quantity observers without dispatching a foreign native variant event.
    colorProperty.dispatchEvent(new Event('change', { bubbles: true }));
  }
  members.forEach(member => {
    const button = element('button', 'beanie-family__color'); button.type = 'button'; button.title = member.color;
    button.setAttribute('aria-label', member.color); button.style.setProperty('--beanie-color', member.swatch);
    button.append(element('span')); button.addEventListener('click', () => choose(member)); buttons.append(button);
  });
  form.addEventListener('formdata', event => {
    if (!current?.variant?.available) { event.formData.set('id', ''); return; }
    event.formData.set('id', String(current.variant.id));
    event.formData.set('properties[Design color]', current.color);
    // All existing personalization and Upload-Lift fields stay in this same native form.
  });
  form.addEventListener('submit', event => {
    if (current?.variant?.available && idInput?.value === String(current.variant.id)) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  const picker = details.querySelector('variant-picker');
  (picker || title).insertAdjacentElement('afterend', box);
  nativeGallery.insertAdjacentElement('afterend', gallery);
  nativeGallery.classList.add('beanie-family-native-gallery');
  document.body.dataset.beanieFamily = 'true';
  const variant = new URL(location.href).searchParams.get('variant');
  choose(members.find(p => String(p.variant?.id) === variant) || members.find(p => p.handle === initial) || members[0]);
}
init();
document.addEventListener('shopify:section:load', init);
